var map = {
	"./background-desktop.webp": 1336,
	"./background-quick-start.webp": 6347,
	"./background-testimonials-desktop.webp": 7063,
	"./banner-about-desktop.webp": 8378,
	"./banner-about-mobile.webp": 4998,
	"./banner-home-desktop.webp": 935,
	"./banner-home-mobile.webp": 3458,
	"./banner-queries-desktop.webp": 9540,
	"./banner-queries-mobile.webp": 6239,
	"./banner-testimonials-desktop.webp": 5429,
	"./banner-testimonials-mobile.webp": 6599,
	"./products/statistics-benefits-product.webp": 7453,
	"./products/statistics-budgets-product.webp": 8564,
	"./products/statistics-finances-product.webp": 1420,
	"./products/statistics-metrics-product.webp": 3340,
	"./quick-start-desktop.webp": 7419,
	"./succes-stories/alvarado.webp": 977,
	"./succes-stories/calcagno.webp": 9559,
	"./succes-stories/details/alvarado_1.webp": 8208,
	"./succes-stories/details/alvarado_2.webp": 4168,
	"./succes-stories/details/alvarado_3.webp": 2784,
	"./succes-stories/details/alvarado_hero.webp": 820,
	"./succes-stories/details/calcagno-hero.webp": 57,
	"./succes-stories/details/calcagno_1.webp": 6637,
	"./succes-stories/details/calcagno_2.webp": 428,
	"./succes-stories/details/calcagno_3.webp": 5177,
	"./succes-stories/details/calcagno_mobile-1.webp": 4058,
	"./succes-stories/details/calcagno_mobile-2.webp": 7772,
	"./succes-stories/details/corti_2.webp": 4740,
	"./succes-stories/details/corti_3.webp": 6015,
	"./succes-stories/details/dentist_tablet.webp": 6058,
	"./succes-stories/details/marion_1.webp": 3681,
	"./succes-stories/details/marion_2.webp": 3548,
	"./succes-stories/details/marion_3.webp": 8965,
	"./succes-stories/details/marion_hero.webp": 9026,
	"./succes-stories/details/marion_mobile-1.webp": 5442,
	"./succes-stories/details/marion_mobile-2.webp": 5415,
	"./succes-stories/details/orono_1.webp": 4294,
	"./succes-stories/details/orono_2.webp": 7829,
	"./succes-stories/details/orono_3.webp": 5309,
	"./succes-stories/details/orono_hero.webp": 3179,
	"./succes-stories/details/orono_mobile-1.webp": 7336,
	"./succes-stories/details/orono_mobile-2.webp": 7238,
	"./succes-stories/details/tantera_1.webp": 770,
	"./succes-stories/details/tantera_3.webp": 9646,
	"./succes-stories/marion.webp": 5028,
	"./succes-stories/orono.webp": 3552,
	"./succes-stories/stacks/alvarado.webp": 6108,
	"./succes-stories/stacks/calcagno.webp": 7601,
	"./succes-stories/stacks/marion.webp": 2221,
	"./succes-stories/stacks/orono.webp": 6515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7226;